import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const CompareAlert1ToMobileHelpPage: React.FC = () => {
  const { getImage } = useImages();
  const heroImage = getImage('compare-alert1-mobile-help-mobile-medical-alert-pendant.jpg');
  
  // Reason icons
  const savingsIcon = getImage('compare-alert1-savings-icon.jpg');
  const responseIcon = getImage('compare-alert1-response-icon.jpg');
  const buttonPushIcon = getImage('compare-alert1-button-push-icon.jpg');
  const monthlyPlanIcon = getImage('compare-alert1-monthly-plan-icon.jpg');
  const helpIcon = getImage('compare-alert1-help-icon.jpg');
  const valueImage = getImage('7-Price-Compare-Fall-Detection-Medical-Alert.jpg');
  const familyImage = getImage('8-Price-Compare-Mobile-Medical-Alert.jpg');

  return (
    <div className="compare-alert1-to-mobilehelp-page compare-alert1-to-life-alert-page">
      {/* Hero Section */}
      <section className="compare-hero-new">
        <div className="compare-hero-container">
          <div className="compare-hero-content">
            <h1>Alert1 Medical Alert Systems: The Ideal Alternative to MobileHelp</h1>
            
            <p className="compare-hero-text">
              Alert1 believes staying safe should be affordable and effortless, offering easy-to-use medical alert devices for seniors with flexible pricing plans. Compare in-home and mobile medical alert prices and systems to MobileHelp—you'll find Alert1 has many of the same features (or more) at a great price¹.
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <Link to="/medical-alerts" className="btn btn-primary compare-hero-btn">
                VIEW SYSTEMS
              </Link>
            </div>
          </div>
          
          <div className="compare-hero-image">
            <div className="circular-image-wrapper">
              {heroImage ? (
                <img 
                  src={heroImage} 
                  alt="Elderly man in shower wearing medical alert wristband" 
                  className="circular-image"
                />
              ) : (
                <div className="circular-image-placeholder" />
              )}
            </div>
            <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                Call <strong>1-877-573-4195</strong> today and
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                see why Alert1 is the best
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                medical alert system provider for
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                you or your loved one.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Chart Section */}
      <section className="comparison-section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, margin: '0', padding: '0', lineHeight: '1.1', display: 'block' }}>Alert1 and MobileHelp Medical Alert Systems Comparison Chart</h2>
            <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, margin: '0', padding: '0', lineHeight: '1.1', display: 'block' }}>(Cost & Service)</h2>
          </div>
          
          <p className="section-intro" style={{ maxWidth: '900px', margin: '0 auto 2rem auto', fontSize: '1.15rem', lineHeight: '1.7', color: '#333' }}>
            If you're considering MobileHelp, please know that Alert1 has some of the most affordable{' '}
            <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>medical alert devices</Link>
            {' '}for seniors in the industry today. You'll discover in-home and on-the-go systems, with great safety features like fall detection and GPS. Our trained emergency response agents are standing by 24/7/365 to get you the fast help you need in an emergency, and unlike many of our competitors, we stay on the line with our members until help arrives, so <strong><em>no one ever faces an emergency alone.</em></strong>
          </p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="highlight-col">Alert1</th>
                  <th>MobileHelp</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Prices Starting At</strong>
                    <br />
                    <Link to="/pricing" style={{ fontSize: '0.9rem', color: '#0066cc', textDecoration: 'underline' }}>See Pricing</Link>
                  </td>
                  <td className="highlight-col">$19.95/mo<sup>1</sup></td>
                  <td>$19.95/mo<sup>2</sup></td>
                </tr>
                <tr>
                  <td><strong>No Long-Term Contract Required</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Nationwide Coverage</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>UL Listed</strong><br /><small>Monitoring center</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>BBB Accredited Business</strong><br /><small>A+ rating from the Better Business Bureau</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Unknown</td>
                </tr>
                <tr>
                  <td><strong>Constant Care</strong><br /><small>We stay on the phone until help arrives</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Multilingual Protection</strong><br /><small>Responders speak 190 different languages</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Same Day Shipping</strong><br /><small>For 85% or more of orders</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Unlimited Button Pushes</strong><br /><small>Never charges for pushing your button</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Thayer Certified</strong><br /><small>Safe, fair working environment</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>TMA 5 Diamond Certified Command Center</strong><br /><small>Ensures that each center meets only the highest standards</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>Modern Senior Magazine<sup>*</sup></strong><br /><small>#1 Rated Medical Alert System</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 5 Reasons Section */}
      <section className="reasons-section" style={{ background: 'white' }}>
        <div className="container">
          <h2>5 Reasons Why Alert1 is the Best MobileHelp Alternative</h2>
          
          <div className="reasons-list">
            <div className="reason-item">
              <div className="reason-icon">
                {savingsIcon && (
                  <img src={savingsIcon} alt="Value" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">1.</span> Value</h4>
                <p>
                  We have systems to meet every need, lifestyle, and budget (invaluable protection at affordable pricing)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {responseIcon && (
                  <img src={responseIcon} alt="Support" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">2.</span> Support</h4>
                <p>
                  Once a member sends an alert, our emergency response team stays on the line with them until help 
                  arrives (not all companies do this)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {buttonPushIcon && (
                  <img src={buttonPushIcon} alt="Simple" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">3.</span> Simple</h4>
                <p>
                  One button push connects you to trained operators who are ready to help 24/7/365
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {monthlyPlanIcon && (
                  <img src={monthlyPlanIcon} alt="Flexible" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">4.</span> Flexible</h4>
                <p>
                  No long-term contracts required—choose monthly or annual billing with easy cancellation
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {helpIcon && (
                  <img src={helpIcon} alt="Helpful" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">5.</span> Helpful</h4>
                <p>
                  Our customer service team is knowledgeable, friendly, and always ready to assist with questions or concerns
                </p>
              </div>
            </div>
          </div>

          <div className="cta-center">
            <Link to="/medical-alerts" className="btn btn-primary">TRY US TODAY</Link>
          </div>
        </div>
      </section>

      {/* Can MobileHelp Match Alert1's Benefits and Value Section */}
      <section className="alternative-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <div style={{ display: 'flex', gap: '3rem', marginTop: '3rem', alignItems: 'flex-start' }}>
            <div style={{ flexShrink: 0 }}>
              <div className="circular-image-wrapper">
                {valueImage ? (
                  <img 
                    src={valueImage} 
                    alt="Elderly man with walker wearing medical alert pendant" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <div style={{ flex: 1 }}>
              <h2>Can MobileHelp Match Alert1's Benefits and Value?</h2>
              
              <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem', marginTop: '1.5rem' }}>
                <li>Alert1 agents stay on the line until help arrives, unlike some other companies, to assist during frightening emergencies.</li>
                <li>Discreet, comfortable unisex alarm buttons can be worn as a pendant, wristband, or carried in a pocket.</li>
                <li>Alarm buttons are compatible with pacemakers and are showerproof for use while bathing.</li>
                <li>Systems are pre-programmed, requiring only plugging in and wearing the alarm button.</li>
                <li>Trained emergency operators are available 24/7/365.</li>
                <li>Mobile medical alarm systems have an unlimited range across the USA.</li>
                <li>Alert1 does not charge extra fees for frequent usage.</li>
                <li>Optional fall detection technology and GPS for enhanced security.</li>
                <li>Flexible payment plans, allowing members to pay monthly or several months in advance for discounts.</li>
              </ul>
              
              <div className="cta-center" style={{ marginTop: '2rem' }}>
                <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Join the Alert1 Family Section */}
      <section className="alternative-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center' }}>Join the Alert1 Family of Members</h2>
          
          <div style={{ display: 'flex', gap: '3rem', marginTop: '3rem', alignItems: 'flex-start', maxWidth: '900px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div style={{ flexShrink: 0 }}>
              <div className="circular-image-wrapper">
                {familyImage ? (
                  <img 
                    src={familyImage} 
                    alt="Elderly woman with dog wearing medical alert pendant" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <div style={{ flex: 1 }}>
              <p className="section-intro">
                We invite you or your loved one to join our family of members! You may order your new medical alarm service{' '}
                <Link to="/medical-alerts" style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#333' }}>here</Link>
                {' '}on our website, or call one of our New Member Specialists who will be happy to answer any questions and get you set up with your alarm button. It's time to enjoy the security, protection, and peace of mind you'll get from your new medical alert system!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footnotes Section */}
      <section className="alternative-section" style={{ background: '#f5f5f5', padding: '2rem 0' }}>
        <div className="container">
          <div className="table-footnote" style={{ marginTop: '0' }}>
            <p>¹Pricing of Alert1 annual service plans. Cost to buy equipment depends on user location and options. Monthly fee depends on user location and options. Pricing is based on standard rates, temporary promotions may apply, offers subject to change.</p>
            <p>²MobileHelp website accessed on 6/1/2021. Information updated quarterly. MobileHelp is a registered trademark of Integrity Tracking, LLC.</p>
            <p>Medical alert comparisons and pricing are based on standard rates, temporary promotions may apply, offers subject to change. View our competitive advertising guidelines.</p>
            <p>If you would like to request any changes to the information provided here, contact <a href="mailto:marketing@alert1.com" style={{ color: '#0066cc', textDecoration: 'underline' }}>marketing@alert1.com</a></p>
            <p>*Alert1 and Modern Senior Magazine are wholly owned by ResponseLINK, LLC.</p>
            <p>Please note that for all comparisons a lack of a check mark indicates that the competitor criteria is not listed on the competitor's official website.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompareAlert1ToMobileHelpPage;
